module.exports = __webpack_public_path__ + "static/media/loading.7090d284.gif";